<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <main class="register">
    <form>
      <img class="img_glow_left" src="/static/images/home/glow.png">
      <section class="reg_3">
        <h1>{{ $_getTranslations.visitor_sign_up_register_three_steps }}</h1>
        <read-only-stepper-header
          :total-steps="3"
          :active-step="3"
        ></read-only-stepper-header>

        <img src="/static/images/register/mobile_img.svg" class="register_mobile" alt="mobile image">

        <p>{{ $_getTranslations.visitor_sign_up_3_connect_fb_or_create_username }}</p>

        <facebook-login  v-if="facebookFunctionality"
                         :errorsInFb="errorInFb"
                        :enteredUsername="testUser"
                        :type="fbActionType"
                        @errorsUpdated="methodForEvent($event)"
                        @waitForCoreResponse="methodForResponse($event)">
        </facebook-login>


        <div class="error_text par" v-if="errorInFb">
          {{ getFbMessage() }}
        </div>

        <div class="divider" v-if="facebookFunctionality">
          <span>{{ $_getTranslations.visitor_sign_up_and_login_or }}</span>
        </div>

        <base-text-form-input
          v-model="user.username"
          :label="$_getTranslations.visitor_sign_up_3_placeholder_create_username"
          :invalid="hasErrorsUsername"
          :input-class="'mobile'"
          :input-id="'mobile'"
          @keyup="check"
        ></base-text-form-input>
        <div class="error_text" v-show="getMessage(messageForUsername)">{{ getMessage(messageForUsername) }}</div>

        <base-password-form-input
          v-model="user.password"
          :label="$_getTranslations.visitor_sign_up_3_placeholder_create_password"
          :invalid="hasErrorsPassword"
          @keyup="checkPassword"
        ></base-password-form-input>

        <div class="error_text" v-show="getMessage(messageForPassword) && user.password">{{ getMessage(messageForPassword) }}</div>
        <div class="error_text" v-show="getMessage(messageForFinalPassword)">{{ getMessage(messageForFinalPassword) }}</div>

        <base-password-form-input
          v-model="user.confirmPassword"
          :label="$_getTranslations.visitor_sign_up_3_placeholder_confirm_password"
          :invalid="hasErrorsConfirmPassword"
          :input-class="'repeat'"
          @keyup="checkPassword"
        ></base-password-form-input>

        <div class="error_text" v-show="getMessage(messageForConfirmPassword) && user.confirmPassword">{{ getMessage(messageForConfirmPassword) }}</div>
        <div class="error_text" v-show="getMessage(finalMessage)">{{ getMessage(finalMessage) }}</div>

        <div class="divider">
          <span>&</span>
        </div>

        <governorate-selection
          v-model="selectedGovernorate"
        ></governorate-selection>
        <div class="error_text" v-show="getMessage(messageForGovernorate)">{{ getMessage(messageForGovernorate) }}</div>
      </section>

      <avatar-selection-carousel></avatar-selection-carousel>
      <div class="error_text" v-show="getMessage(messageForAvatar)">{{ getMessage(messageForAvatar) }}</div>

      <section>
        <div class="remember_checkbox">
          <input
            id="remember_me"
            type="checkbox"
            v-model="rememberMeParameter"
            checked="">
          <label for="remember_me">{{ $_getTranslations.common_remember_me }}</label>
        </div>

        <base-button
          :disabled="waitForResponse || hasErrorsUsername || hasErrorsPassword || hasErrorsConfirmPassword"
          :container-class="'finish'"
          @button:click.prevent="checkButton">
          {{ $_getTranslations.visitor_sign_up_3_submit_button_sign_up }}
        </base-button>
      </section>
    </form>
    <loading v-if="showPleaseWait"
             @close="showPleaseWait = false">
    </loading>
  </main>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import loading from '@/components/home/modals/Loading';
import RegistrationFlowMixin from '../../../common/mixins/flow';
import FacebookLogin from '.././FacebookLogin';
import BaseTextFormInput from "../../common/formInput/BaseTextFormInput";
import BaseButton from "../../common/button/BaseButton";
import translationMixin from "../../../common/mixins/translation";
import ReadOnlyStepperHeader from "../../common/header/ReadOnlyStepperHeader";
import AvatarSelectionCarousel from "../../common/carousel/AvatarSelectionCarousel";
import GovernorateSelection from "../../common/formInput/GovernorateSelection";
import BasePasswordFormInput from "../../common/formInput/BasePasswordFormInput";
import {setLocalStorageValueByUser} from '../../../helpers/user'

export default {
  components: {
    BasePasswordFormInput,
    FacebookLogin,
    loading,
    BaseTextFormInput,
    BaseButton,
    ReadOnlyStepperHeader,
    AvatarSelectionCarousel,
    GovernorateSelection,
  },
  name: 'sign-up-3',
  mixins: [RegistrationFlowMixin, translationMixin],
  data() {
    return {
      show: true,
      testUser: 'User',
      waitForResponse: false,
      user: {
        username: '',
        password: '',
        confirmPassword: '',
        proposedUsername: '',
      },
      proposedUsername: '',
      username: '',
      fbActionType: 'register',
      errorInFb: false,
      messageForPassword: '',
      messageForUsername: '',
      messageForConfirmPassword: '',
      messageForFinalPassword: '',
      hasErrorsUsername: false,
      hasErrorsPassword: false,
      hasErrorsConfirmPassword: false,
      finalMessage: '',
      message: '',
      tokenExists: false,
      rememberMeParameter: true,
      fbMessageUsernameError: '',
      selectedGovernorate: '',
      hasErrorsAvatar: false,
      hasErrorsGovernorate: false,
      messageForAvatar: '',
      messageForGovernorate: ''
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.showPage(false);
      vm.checkExternalSubscription(to);
    });
  },
  created() {
    const operator = this.$route.query.operator;
    if (operator) {
      this.storeOperator(operator);
    }
  },
  methods: {
    ...mapMutations('profile', [
      'setShowPleaseWait',
      'setRegistrationInfo',
      'setFirstTimeEntry',
    ]),
    ...mapActions('common', [
      'storeOperator',
      'sendAvatarCall',
    ]),
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'callForAuthorization',
      'getUserLoginDetails',
      'updateGovernorate',
    ]),
    showPage(value) {
      this.show = value;
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.$_getTranslations[key] || '';
    },
    getFbMessage() {
      if (!this.fbMessageUsernameError) return this.$_getTranslations.visitor_sign_up_3_this_fb;
      return this.$_getTranslations.visitor_sign_up_3_fb_username_first;
    },
    methodForEvent(event) {
      this.errorInFb = event;
    },
    methodForResponse(event) {
      this.waitForResponse = event;
    },
    checkExternalSubscription(to) {
      if (to.query.msisdn && to.query.date && to.query.lang && to.query.digest) {
        const msisdn = encodeURIComponent(to.query.msisdn);
        const mergedParams = to.query[this.mergedParam] ? encodeURIComponent(to.query[this.mergedParam]) : '';
        this.$axios.get(`api/externalSubscribe?msisdn=${msisdn}&lang=${to.query.lang}&date=${encodeURIComponent(to.query.date)}&signature=${encodeURIComponent(to.query.digest)}&params=${mergedParams}`).then((response) => {
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (!this.isString(response.data.data) && this.hasSimplify()) {
              if (response.data.data.result === 'SUCCESS') {
                this.storeLoginInfo({
                  token: response.data.data.token,
                  rememberMeParameter: this.rememberMeParameter,
                  username: response.data.data.username,
                });
                this.getUserLoginDetails().then(() => {
                  this.setFirstTimeEntry(true);
                  this.updateUserLanguage();
                  this.$router.push('home');
                });
              }
            }
            if (response.data.data === 'SUCCESS') {
              this.showPage(true);
              this.setRegistrationInfo(msisdn);
            } else if (response.data.data === 'ALREADY_REGISTERED') {
              this.$router.push('/login');
            } else {
              this.$router.push('/');
            }
          } else {
            this.$router.push('/');
          }
        });
      } else this.showPage(true);
    },
    check(evt) {
      const max = 12;
      const min = 3;
      this.messageForFinalPassword = '';
      this.finalMessage = '';
      this.errorInFb = false;
      this.hasErrorsUsername = false;
      this.messageForUsername = '';
      if (this.user.username === '') {
        this.hasErrorsUsername = false;
      } else {
        // eslint-disable-next-line
        if (this.user.username.length < min) {
          this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_at_least_3_chars_long';
          this.user.proposedUsername = '';
          this.hasErrorsUsername = true;
        } else {
          this.messageForUsername = '';
          if (this.user.username.length > max) {
            this.user.username = this.checkMaxChar(this.user.username, max, evt);
            this.hasErrorsUsername = true;
          }
          this.hasErrorsUsername = false;
          // eslint-disable-next-line
          const validUsernameRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
          const validUsername = this.user.username.match(validUsernameRegex);
          if (validUsername === null) {
            this.hasErrorsUsername = true;
            this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_criteria';
            return;
          }
          this.$axios.get(`publicapi/checkUsername?username=${this.user.username}&msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}`).then((response) => {
            const res = response.data.data.msg;
            if (res === 'Username exists') {
              this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_taken_below';
              this.hasErrorsUsername = true;
            } else if (res === 'Invalid') {
              this.hasErrorsUsername = true;
              this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_blacklist_word';
            } else {
              this.messageForUsername = response.data.data.msg;
            }
            this.user.proposedUsername = response.data.data.prpusn;
          });
        }
      }
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /* eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          // e.which < 0x20, then it's not a printable character
          // e.which === 0 - Not a character
          return;     // Do nothing
        }
        if (value.length === max) {
          charCode.preventDefault();
        } else if (value.length > max) {
          // Maximum exceeded
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    checkPassword(evt) {
      const min = 4;
      const max = this.maximumDigitsPinLength;
      this.messageForFinalPassword = '';
      this.messageForConfirmPassword = '';
      this.messageForPassword = '';
      this.finalMessage = '';
      this.errorInFb = false;
      // eslint-disable-next-line
      const validPasswordRegex = /^[0-9]{0,8}$/;
      const validPassword = this.user.password.match(validPasswordRegex);
      this.hasErrorsPassword = false;
      if (this.user.password.length < min || this.user.confirmPassword.length > max) {
        if (this.user.password.length < min) {
          this.messageForPassword = 'visitor_sign_up_3_info_wrong_password_warning_msg_at_least_6_chars';
          this.hasErrorsPassword = true;
        }
        if (this.user.confirmPassword.length > max) {
          this.user.confirmPassword = this.checkMaxChar(this.user.confirmPassword, max, evt);
          this.checkPassword();
        }
      } else if (this.user.password.length > max) {
        this.user.password = this.checkMaxChar(this.user.password, max, evt);
        this.hasErrorsPassword = true;
        this.checkPassword();
      } else if (validPassword !== null) {
        if (this.user.password.length > max) {
          this.user.password = this.checkMaxChar(this.user.password, max, evt);
          this.hasErrorsPassword = true;
          this.checkPassword();
        }
        this.messageForPassword = '';
        if (this.user.confirmPassword.length < min) {
          this.messageForConfirmPassword = 'visitor_sign_up_3_passwords_do_not_match';
          this.hasErrorsPassword = true;
          this.hasErrorsConfirmPassword = true;
        }
        if (this.user.confirmPassword !== '' && (this.user.confirmPassword === this.user.password)) {
          this.messageForConfirmPassword = '';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = false;
        } else {
          this.messageForConfirmPassword = 'visitor_sign_up_3_passwords_do_not_match';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = true;
        }
      } else if (validPassword === null) {
        this.hasErrorsPassword = true;
        // eslint-disable-next-line
        this.messageForPassword = 'visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from';
      }
      if (this.user.password === '') {
        this.hasErrorsPassword = false;
        this.hasErrorsConfirmPassword = false;
      } else if (this.user.confirmPassword === '') {
        this.hasErrorsConfirmPassword = false;
      }
    },
    change() {
      this.user.proposedUsername = '';
      this.finalMessage = '';
      this.hasErrorsUsername = false;
      this.messageForUsername = '';
      this.errorInFb = false;
      this.messageForFinalPassword = '';
    },
    checkButton() {
      this.hasErrorsAvatar = false;
      this.messageForAvatar = '';
      this.hasErrorsGovernorate = false;
      this.messageForGovernorate = '';

      this.errorInFb = false;
      if (!localStorage.getItem('Avatar')) {
        this.hasErrorsAvatar = true;
        this.messageForAvatar = 'visitor_sign_up_msg_warning_avatar';
      }
      if (this.governorateLength > 0 && this.selectedGovernorate === '') {
        this.hasErrorsGovernorate = true;
        this.messageForGovernorate = 'visitor_sign_up_msg_warning_governorate';
      }
      if ((this.user.username !== '') && (this.hasErrorsPassword === false) && (this.hasErrorsUsername === false) && (this.hasErrorsConfirmPassword === false) && !(this.user.password === '') && !(this.user.confirmPassword === '') && (this.hasErrorsAvatar === false) && (this.hasErrorsGovernorate === false)) {
        this.messageForUsername = '';
        this.waitForResponse = true;
        this.$axios.get(`api/subscribeUser?msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}&username=${this.user.username}&password=${this.user.password}&lang=${this.getLocale}&fbReferral=${this.fbReferral}&freePlayPoints=${this.freeTrialUserPrice || ''}&operator=${this.multiOperatorInfo.operatorPicked || ''}`).then((responseUser) => {
          const res = responseUser.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.message = '';
            const userData = {
              username: this.user.username,
              password: this.user.password,
              rememberMe: this.rememberMeParameter,
            };
            console.log(userData)
            console.log('Before /auth')
            this.callForAuthorization(userData).then(() => {
              console.log(this.getUserAuthorized)
              if (this.getUserAuthorized) {
                this.getUserLoginDetails().then(() => {
                  setLocalStorageValueByUser('levelUp', this.userDetails.msisdn, {level: this.userDetails.level, rewardPoints: null});
                  this.setFirstTimeEntry(true);
                  this.updateUserLanguage().then(() => {
                    this.sendAvatarCall().then(() => {
                      if (this.governorateLength > 0) {
                        this.updateGovernorate({ governorate: this.selectedGovernorate }).then(() => {
                          this.$router.push('home');
                          this.waitForResponse = false;
                        });
                      } else {
                        this.$router.push('home');
                        this.waitForResponse = false;
                      }
                    });
                  });
                });
              } else {
                this.message = 'SERVER_ERROR';
                this.waitForResponse = false;
              }
            });
          } else {
            // eslint-disable-next-line
            if (res === 'MSISDN_INVALID') {
              this.finalMessage = 'visitor_sign_up_invalid_msisdn_msg';
            } else if (res === 'ALREADY_REGISTERED') {
              this.finalMessage = 'visitor_sign_up_msisdn_already_registered';
            } else if (res === 'MSISDN_NOT_EXIST') {
              this.finalMessage = 'visitor_sign_up_msisdn_not_exists';
            } else if (res === 'MSISDN_BLACKLISTED') {
              this.finalMessage = 'visitor_sign_up_msisdn_blacklisted';
            } else if (res === 'BLOCKED_USER') {
              this.finalMessage = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (res === 'SERVER_ERROR') {
              this.finalMessage = 'home_profile_profile_edit_server_unvailable';
            }
            this.waitForResponse = false;
          }
        });
      } else {
        // eslint-disable-next-line
        if (this.user.username === '') {
          this.hasErrorsUsername = true;
          this.messageForUsername = 'visitor_sign_up_3_fb_username_first';
        } else if (this.user.password === '') {
          this.hasErrorsPassword = true;
          this.messageForPassword = '';
          this.messageForFinalPassword = 'visitor_sign_up_3_info_wrong_password_warning_msg_at_least_6_chars';
        } else if (this.user.confirmPassword === '') {
          this.hasErrorsConfirmPassword = true;
          this.messageForConfirmPassword = '';
          this.finalMessage = 'visitor_sign_up_3_passwords_do_not_match';
        }
      }
    },
  },
  computed: {
    ...mapState('common', [
      'integrationHeader',
      'availableIntegrations',
      'freeTrialUserPrice',
      'facebookFunctionality',
      'fbReferral',
      'multiOperatorInfo',
      'mergedParam',
      'maximumDigitsPinLength',
      'governorateLength',
      'userDetails',
    ]),
    ...mapState('game', [
      'registrationPoints',
    ]),
    ...mapState('profile', [
      'showPleaseWait',
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp3.vue